<template>
  <div v-if="!canAccessPage">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar />
    <div class="container-xxl">
      <div class="card mb-5">
        <div class="card-body pt-0">
          <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-8">
            <li class="nav-item" v-if="canAccessShare">
              <a
                class="nav-link text-active-primary pb-4"
                :class="{ active: activeTab === 'share' }"
                href="#"
                @click.prevent="activeTab = 'share'"
              >
                Compartilhamento
              </a>
            </li>
          </ul>

          <TabShare v-if="activeTab === 'share' && canAccessShare" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toolbar from "@/components/layouts/auth/Toolbar.vue";
import TabShare from "./TabShare.vue";
import permission from "@/helpers/permission";
import { hasPlanFeature } from "@/helpers/platformFeature";

export default {
  name: "MedicalRecordSettings",
  components: { Toolbar, TabShare },
  data() {
    return {
      activeTab: 'share',
    };
  },
  computed: {
    canAccessShare() {
      return permission.has('Share Medical Record') && hasPlanFeature('prontuario.record_sharing');
    },
    canAccessPage() {
      return this.canAccessShare;
    },
  },
  watch: {
    canAccessShare: {
      immediate: true,
      handler(canShare) {
        if (canShare) {
          this.activeTab = 'share';
        }
      },
    },
  },
};
</script>
